import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function DrawPencil({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 18 17' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.84921 12.4577L14.5868 5.72005C14.8972 5.40972 15.3996 5.40972 15.7091
        5.72005L16.5647 6.57565C16.8751 6.88599 16.8751 7.38839 16.5647 7.69793L9.8255
        14.4372C9.61676 14.6459 9.35405 14.7919 9.06752 14.8594L7.75952 15.1681C7.37538
        15.2586 7.03012 14.9142 7.11981 14.5292L7.42617 13.2188C7.49364 12.9307 7.64047
        12.6672 7.84921 12.4577V12.4577Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.3223 6.97852L15.3065 8.96274'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.96845 15.2864H4.84861C2.7231 15.2864 1 13.5633 1 11.4378V11.4378C1 9.91711
        1.89528 8.53847 3.28583 7.92098L6.42884 6.52409C7.47175 6.06057 8.14322 5.02719
        8.14322 3.88665V3.88665C8.14322 2.29213 6.85109 1 5.25656 1H4.96845'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

DrawPencil.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default DrawPencil
